<template>
  <a-card bordered :loading="loading">
    <div slot="title">
      <a-icon type="pic-center" />
      <span class="margin-left">{{ title }}</span>
    </div>
    <template v-if="!hasExtraSlot && noAction">
      <a-button
        type="primary"
        slot="extra"
        icon="plus"
        v-if="!disabledCreateEditLink"
        @click="handleCreate"
      >
        Create
      </a-button>
    </template>
    <template slot="extra" v-else-if="hasExtraSlot && noAction">
      <slot name="extra_action"></slot>
    </template>

    <a-list
      itemLayout="vertical"
      :dataSource="dataList"
      :pagination="pagination"
    >
      <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
      <a-list-item
        :class="item.unread ? '' : 'read'"
        slot="renderItem"
        slot-scope="item"
      >
        <router-link
          :to="{
            name: manifestLink,
            params: {
              id: item.id,
              user_pembuat: item.user_pembuat,
              rabview: rab,
            },
          }"
        >
          <a-list-item-meta>
            <div slot="description">
              <slot :item="item" name="status"></slot>
              <div class="m-display-flex space-between">
                <div :style="getScreen ? 'width:100%' : 'width:50%'">
                  <h4
                    class="m-list-title m-text-bold margin-remove"
                    :class="item.unread ? '' : 'color-black'"
                  >
                    {{ item.title }}
                  </h4>
                  <a-tooltip
                    v-if="typeof item.subtitle === 'object'"
                    class="m-tooltip-inner"
                    placement="top"
                    :title="item.subtitle.deskripsi"
                  >
                    <span class="m-text-ellipse">{{
                      item.subtitle.deskripsi
                    }}</span>
                  </a-tooltip>
                  <span v-else class="m-display-block">{{
                    item.subtitle
                  }}</span>

                  <ul class="m-list-wrapper">
                    <li
                      v-for="(items, index) in item.subdesc"
                      :key="index"
                      class="margin-remove"
                    >
                      <span
                        v-if="
                          !Array.isArray(items) && typeof items !== 'object'
                        "
                        :class="
                          getScreen ? 'mobile-description' : 'm-text-ellipse'
                        "
                        >{{ items }}</span
                      >
                      <a-tooltip
                        v-else-if="typeof items === 'object'"
                        class="m-tooltip-inner"
                        placement="top"
                        :title="items.deskripsi"
                      >
                        <span class="m-text-ellipse">{{
                          items.deskripsi
                        }}</span>
                      </a-tooltip>
                      <div
                        v-else
                        v-for="(subItem, index) in items"
                        :key="index"
                      >
                        <div class="m-display-flex flex-row space-between">
                          <h4 v-if="item.unread" class="margin-remove">
                            {{ subItem.label }}
                          </h4>
                          <h4 v-else class="m-display-block margin-remove">
                            {{ subItem.label }}
                          </h4>
                          {{ subItem.value }}
                        </div>
                      </div>
                      <template v-if="Array.isArray(items)">
                        <div v-for="(subItem, index) in items" :key="index">
                          <div class="m-display-flex flex-row space-between">
                            <h4 v-if="item.unread" class="margin-remove">
                              {{ subItem.label }}
                            </h4>
                            <h4 v-else class="m-display-block margin-remove">
                              {{ subItem.label }}
                            </h4>
                            {{ subItem.value }}
                          </div>
                        </div>
                      </template>
                    </li>
                  </ul>
                </div>
                <status
                  v-if="!item.timeline && item.status_besar"
                  :status="item.status_besar"
                  class="status"
                />

                <div
                  v-if="item.timeline"
                  :style="getScreen ? 'width: 100%' : 'width:45%'"
                >
                  
                  <!-- timeline -->
                  <div
                    v-if="item.timeline && item.timeline.length>0"
                  >
                    <div class='m-display-flex flex-row space-between margin-top'>
                      <h4 v-if="item.unread" class="margin-top">
                        Workflow Status
                      </h4>
                      <span v-else class="margin-remove">Workflow Status</span>
                    </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item
                        v-for="(timeline, index) in item.timeline"
                        :key="index"
                        class="m-display-flex space-between flex-row nowrap"
                      >
                        <span class="margin-right">{{ timeline.actor }}</span>
                        <status
                          :class="getScreen ? 'margin-remove' : ''"
                          :status="timeline.status"
                        />
                      </a-timeline-item>
                    </a-timeline>
                    <!-- <div
                      class="file-status"
                      v-if="fileStatus && item.is_uploaded !== null"
                    >
                      <div class="list">
                        <slot :item="item" name="status_file"></slot>
                      </div>
                    </div> -->
                  </div>
                  <div
                      class="file-status"
                      v-if="fileStatus && item.is_uploaded !== null"
                    >
                      <div class="list">
                        <slot :item="item" name="status_file"></slot>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </a-list-item-meta>
        </router-link>
        <slot name="actions" :source="item"></slot>
      </a-list-item>
    </a-list>
  </a-card>
</template>

<script>
import CurrencyFormat from "@/mixins/CurrencyFormat";
import { mapGetters } from "vuex";
export default {
  name: "datalistslot-component",
  props: {
    title: String,
    createLink: String,
    disabledCreateEditLink: Boolean,
    editLink: String,
    manifestLink: String,
    rab: Boolean,
    fileStatus: {
      type: Boolean,
      default: false,
    },
    noAction: { type: Boolean, default: true },
    dataList: {
      type: Array,
      required: true,
    },
    loading: Boolean,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      pagination: {
        pageSize: 5,
        size: "normal",
      },
    };
  },
  computed: {
    ...mapGetters(["getScreen"]),
    hasExtraSlot() {
      return !!this.$slots.extra_action;
    },
  },
  methods: {
    handleCreate() {
      this.$router.push({ name: this.createLink });
    },
  },
};
</script>

<style lang="less" scoped>
a {
  color: white !important;
}

.status{
  height: 100%;
}

.mobile {
  &-description {
    white-space: pre-wrap; /* CSS3 */
    white-space: -moz-pre-wrap; /* Firefox */
    white-space: -pre-wrap; /* Opera <7 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* IE */
    overflow-wrap: anywhere;
  }
}

.m-timeline-content {
  border-bottom: 1px solid darken(white, 10);
}

.file-status {
  margin-top: @margin / 2;

  .list {
    padding: @padding / 2 0;
  }
}
</style>
